module.exports = __webpack_public_path__ + "media/virtual-gallery/CustomerAvatar-ed57b239.png";